// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","animation":"Spinner_animation__okooq","loading-spinner":"Spinner_loading-spinner__9mBb5","info":"Spinner_info__MlP5E"};